export const DEFAULT_PAGE_SIZE = 10;

/** Keycloak realm role (under the incentive-activation resource client) required to activate an incentive. */
export const INCENTIVE_ACTIVATION_ROLE = 'campaign_incentive:active';
